import React, { Component } from 'react'
import './ProfileDetails.css';
import Footer from '../../component/Footer/Footer'
import LayoutWrapper from '../../component/LayoutWrapper/'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { showProfile, doProfileDetailsListRes} from '../../action/ProfileDetailsListAction'

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class ProfileDetails extends Component {

    constructor(){
        super();
        this.state = { 
            profileData: []
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);  

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    } 

    componentDidMount(){        
        const data = {
            userId: localStorage.getItem('userId')
        }
        this.props.showProfile(data)
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.doProfileDetailsListRes && nextProps.doProfileDetailsListRes.user){
            if(nextProps.doProfileDetailsListRes.user && nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes){
                if(nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes && nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.result === true){
                    this.setState({
                        profileData: nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.profile
                    })
                }
            }
        }
    }

    updateProfileDataView=()=>{
        this.props.history.push('/profile-update',{
            profileViewData : this.state.profileData
        })
    }

    render() {
       

        return (
            
            <React.Fragment>
                <LayoutWrapper />

                    <main className="main">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Profile Details</li>
                                </ol>
                            </div>
                             {/* End .container  */}
                        </nav>
                        <div className="container">
                            <div className="col-xl-6 col-lg-12 col-md-12">
                                <div className="card">
                                    <div className="row">                                        
                                        <div className="card-body">
                                            <span className="plus_icon" onClick={() =>this.updateProfileDataView()}>
                                                <i className="fa fa-user-edit"></i>
                                            </span>
                                            <div className="row">                                                
                                                <table className="left40">
                                                    <tr>
                                                        <th className="small text-muted pr-2" scope="row">Name : </th>
                                                        {this.state.profileData && this.state.profileData.map((item, i)=>(
                                                        <td key={i}>{item.first_name}</td>
                                                        ))}
                                                    </tr>
                                                    <tr>
                                                        <th className="small text-muted pr-2" scope="row">EmailId :</th>
                                                        {this.state.profileData && this.state.profileData.map((item, i)=>(
                                                        <td key={i}>{item.user_email}</td>
                                                        ))}
                                                    </tr>
                                                    <tr>
                                                        <th className="small text-muted pr-2" scope="row">Contact: </th>
                                                        {this.state.profileData && this.state.profileData.map((item, i)=>(
                                                        <td key={i}>{item.mobile}</td>
                                                        ))}
                                                    </tr>
                                                </table>                                         
                                            </div>                                
                                        </div>                               
                                    </div>
                                </div>
                            </div>
                            {/* End .row */}
                        </div>
                         {/* End .container  */}
                        <div className="mb-5"></div>
                         {/* margin  */}
                    </main>
                     {/* End .main */}

                <Footer />
            </React.Fragment>
        )
    }
}

ProfileDetails.propTypes = {
    doProfileDetailsListRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doProfileDetailsListRes: doProfileDetailsListRes,
});

function mapDispatchToProps(dispatch) {
    return {
        showProfile: (data) => dispatch(showProfile(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ProfileDetails)
